export default __webpack_public_path__ + "static/media/web3modal-logo.d8a1141a.png";